__turbopack_context__.v({
  "ActiveRow": "Explorer-module-scss-module__2mUuXW__ActiveRow",
  "File": "Explorer-module-scss-module__2mUuXW__File",
  "Folder": "Explorer-module-scss-module__2mUuXW__Folder",
  "FolderDragEnter": "Explorer-module-scss-module__2mUuXW__FolderDragEnter",
  "FolderDraggedInto": "Explorer-module-scss-module__2mUuXW__FolderDraggedInto",
  "FolderIcon": "Explorer-module-scss-module__2mUuXW__FolderIcon",
  "FolderOrFileIndicatorIcon": "Explorer-module-scss-module__2mUuXW__FolderOrFileIndicatorIcon",
  "flash": "Explorer-module-scss-module__2mUuXW__flash",
});
